const div = document.getElementById('routes-served');
const portCode = div?.getAttribute('data-port-code');
const locationCode = div?.getAttribute('data-location-code');
const vesselCode = div?.getAttribute('data-vessel-code');

const routesServedConfig = {
  portCode,
  locationCode,
  vesselCode,
};

export default routesServedConfig;
